import React, {Component, Fragment} from 'react';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';

const initialState = {
}

class SnsRelationSelect extends Component {
  state = initialState;

  componentDidMount() {

    // セッションストレージにSNSログイン情報が存在しない場合、システムエラー画面へ遷移する
//    if (!sessionStorage.getItem('SNSLOGIN')) {
//      this.props.history.push({
//        pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
//      });
//    }
//    else {
      // GA計測用データレイヤースクリプトを追加する
      window.addDataLayerScript('jmbauth_sns_start');
//    }
  }

  // ［連携する］ボタン押下時処理
  snsRelation = () => {

    // SNS認証紐付け確認画面に遷移する
    window.location.href = `${process.env.REACT_APP_CONTEXT_PATH}/sns_relation`;
  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // RP別デザインを取得する
    let designI01;
    // デザイン定義ファイルを読み込み
    let designJson = require('../jsonFile/design.json');

    // 画面、項目ID、デザイン値に該当するデザインファイルを読み込む
    Object.keys(designJson.snsRelationSelect.I01).forEach(function(data) {
      if (data === sessionStorage.getItem('design')) {
        designI01 = require('./design/' + designJson.snsRelationSelect.I01[data]);
      }
    });

    return (
      <section className="content">

        {/* ブラウザタイトル */}
        <Helmet
          title={messageList.snsRelationSelect.M001_browserTitle} >
        </Helmet>

        {/* 画面タイトル表示部 */}
        <div className="ds-heading ds-heading--lg">
          <h1 className="ds-heading__title">{messageList.snsRelationSelect.M002_pageTitle}</h1>
        </div>

        <div className="contentInner">
          {/* ガイド表示部 */}
          <p className="ds-text">{messageList.snsRelationSelect.M003_guideMessage001}</p>
          <a href={messageList.snsRelationSelect.M021_noticeUrl001} target="_blank" rel="noopener noreferrer" className="ds-textLink ds-textLink--linkBlank u-fw-bold">
            {messageList.snsRelationSelect.M004_guideMessage002}&nbsp;
            <span className="ds-textLink__icon">
              <svg className="ds-icon" width="16" height="15" role="img" aria-label={messageList.snsRelationSelect.M005_newWindowIcon}>
                <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_link_blank`}></use>
              </svg>
            </span>
          </a>

          {/* JALカード会員以外の方 */}
          {!designI01 &&
          <div className="formPanel">
            <div className="formPanel__inner u-w-12of12">
              <div className="ds-heading ds-heading--sm u-al-center--pc">
                <h2 className="ds-heading__title">{messageList.snsRelationSelect.M006_memberText001}</h2>
              </div>
              <div className="buttonLayout buttonLayout--split">
                <div className="buttonWrap buttonWrap--center">
                  <div className="ds-button ds-button--primary ds-button--large">
                    <button className="ds-button__trigger" type="button" onClick={this.snsRelation}>
                      <span className="ds-button__label">{messageList.snsRelationSelect.M007_link}</span>
                    </button>
                  </div>
                </div>
                <div className="buttonWrap buttonWrap--left">
                  <div className="ds-button ds-button--tertiary ds-button--large">
                    <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                      <span className="ds-button__label">{messageList.snsRelationSelect.M008_back}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>}

          {!designI01 &&
          <div className="formPanel">
            <div className="formPanel__inner u-w-12of12">
              <div className="ds-heading ds-heading--sm u-al-center--pc">
                <h2 className="ds-heading__title">{messageList.snsRelationSelect.M009_nonMemberText001}</h2>
              </div>
              <p className="ds-text u-al-center--pc">{messageList.snsRelationSelect.M011_nonMemberText003}</p>
              {(sessionStorage.getItem("lang") !== 'ja') &&
                  <p className="left">{messageList.snsRelationSelect.M019_nonMemberText009}</p>
              }
              <div className="buttonLayout buttonLayout--split">
                <div className="buttonWrap buttonWrap--left">
                  <div className="ds-button ds-button--secondary ds-button--large">
                    <a className="ds-button__trigger" href="https://www.jal.co.jp/jp/ja/jmb/index09.html">
                      <span className="ds-button__label">{messageList.snsRelationSelect.M012_nonMemberText004}</span>
                    </a>
                  </div>
                </div>
                <div className="buttonWrap buttonWrap--center">
                  <div className="ds-button ds-button--secondary ds-button--large">
                    <a className="ds-button__trigger" href="https://www.jal.co.jp/jp/ja/jmb/jmb-login/join/world/">
                      <span className="ds-button__label">{messageList.snsRelationSelect.M013_nonMemberText005}</span>
                    </a>
                  </div>
                </div>
              </div>
              {(sessionStorage.getItem("lang") === 'ja') ?
              <Fragment>
                <p className="ds-text u-al-center--pc u-mt-40--pc u-mt-24--sp" lang="en">{messageList.snsRelationSelect.M014_nonMemberText006}</p>
                <div className="buttonLayout buttonLayout--split">
                  <div className="buttonWrap buttonWrap--left">
                    <div className="ds-button ds-button--secondary ds-button--large">
                      <a className="ds-button__trigger" href="https://www.jal.co.jp/jp/en/jmb/index09.html" lang="en">
                        <span className="ds-button__label">{messageList.snsRelationSelect.M015_nonMemberText007}</span>
                      </a>
                    </div>
                  </div>
                  <div className="buttonWrap buttonWrap--center">
                    <div className="ds-button ds-button--secondary ds-button--large">
                      <a className="ds-button__trigger" href="https://www.jal.co.jp/jp/en/jmb/jmb-login/join/world/" lang="en">
                        <span className="ds-button__label">{messageList.snsRelationSelect.M016_nonMemberText008}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </Fragment>
              :
              <Fragment>
                <p className="ds-text u-al-center--pc u-mt-40--pc u-mt-24--sp">{messageList.snsRelationSelect.M014_nonMemberText006}</p>
                <p className="left">{messageList.snsRelationSelect.M020_nonMemberText010}</p>
                <div className="buttonLayout buttonLayout--split">
                  <div className="buttonWrap buttonWrap--left">
                    <div className="ds-button ds-button--secondary ds-button--large">
                      <a className="ds-button__trigger" href="https://www.jal.co.jp/jp/en/jmb/index09.html" lang="en">
                        <span className="ds-button__label">{messageList.snsRelationSelect.M015_nonMemberText007}</span>
                      </a>
                    </div>
                  </div>
                  <div className="buttonWrap buttonWrap--center">
                    <div className="ds-button ds-button--secondary ds-button--large">
                      <a className="ds-button__trigger" href="https://www.jal.co.jp/jp/en/jmb/jmb-login/join/world/" lang="en">
                        <span className="ds-button__label">{messageList.snsRelationSelect.M016_nonMemberText008}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </Fragment>
              }
            </div>
          </div>}

          {/* JALカード会員の方 */}
          {designI01 &&
          <div className="formPanel">
            <div className="formPanel__inner u-w-12of12">
              <div className="ds-heading ds-heading--sm u-al-center--pc">
                <h2 className="ds-heading__title">{messageList.snsRelationSelect.M006_memberText002}</h2>
              </div>
              <div className="buttonLayout buttonLayout--split">
                <div className="buttonWrap buttonWrap--center">
                  <div className="ds-button ds-button--primary ds-button--large">
                    <button className="ds-button__trigger" type="button" onClick={this.snsRelation}>
                      <span className="ds-button__label">{messageList.snsRelationSelect.M007_link}</span>
                    </button>
                  </div>
                </div>
                <div className="buttonWrap buttonWrap--left">
                  <div className="ds-button ds-button--tertiary ds-button--large">
                    <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                      <span className="ds-button__label">{messageList.snsRelationSelect.M008_back}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>}

          {/* Rトースターエリア */}
          {(designI01) && designI01.getDesign(sessionStorage.getItem('lang'))}
        </div>

        {/* 案内表示部 */}
        <div className="contentInner">
          <div className="ds-heading ds-heading--sm">
            <h2 className="ds-heading__title">{messageList.snsRelationSelect.M017_notices}</h2>
          </div>
          <ul className="ds-listText ds-listText--md">
            <li className="ds-listText__item">{messageList.snsRelationSelect.M018_notice001}</li>
          </ul>
        </div>

      </section>
    );
  }
}

export default withRouter(SnsRelationSelect)
